<template>
		<span style="padding-left:5px">
      <a-dropdown placement="bottomCenter">
        <div class="ant-avatar antd-pro-components-global-header-index-avatar ant-avatar-sm ant-avatar-circle ant-avatar-image ant-dropdown-link" @click="goToSetting">
          <img class="avatar" v-if="userImage" :src="userImage"/>
          <img class="avatar"  src="../../assets/avatar_icon.png" v-else/>
			  </div>
        <a-menu style="margin-top: 15px" slot="overlay">
          <a-menu-item>
            <span>{{$t('global.hello') + orgName}}</span>
          </a-menu-item>
          <a-menu-item @click="logout">
            <span>
              {{$t('global.logout')}}
          </span>
          </a-menu-item>
        </a-menu>
        <!-- <span slot="overlay" class="avatar-name antd-pro-components-global-header-index-name" style="padding-left:5px">{{$t('global.hello') + orgName}}</span>
          <span @click="logout" class="antd-pro-components-global-header-index-action antd-pro-components-notice-icon-index-noticeButton ant-dropdown-trigger">
              <a class="loginout" href="javascript:;">
                  <span>{{$t('global.logout')}}</span>
              </a>
          </span> -->
      </a-dropdown>
		</span>
</template>

<script>
    import {mapGetters} from 'vuex'
	export default {
		name: 'ZUser',
		data() {
			return {}
		},
        computed: {
            ...mapGetters([
                'username','userImage','orgName'
            ])
        },
		methods: {
			goToSetting(){
			    // this.$router.push('/user/security')
			},
			logout() {
				this.$store.dispatch('logout', "")
				this.$router.push('/login')
			}
		}
	}
</script>

<style lang="less" scoped>
.avatar {
  max-width: 40px;
  vertical-align: middle;
}
</style>
